import {
    SET_UPLOAD,
	RESET_UPLOAD,
    FAILED_UPLOAD,
    BEGIN_UPLOAD
} from '../constants';


export function setUpload(obj) {
    return {
        type: SET_UPLOAD,
        payload: obj
    }
}

export function beginUpload() {
    return {
        type: BEGIN_UPLOAD,
        payload: {}
    }
}

export function failedUpload() {
    return {
        type: FAILED_UPLOAD,
        payload: {}
    }
}

export function resetUpload() {
    return {
        type: RESET_UPLOAD,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/upload.js